// extracted by mini-css-extract-plugin
export default {"container":"_5KQIG","skeleton-progress":"QgheZ"};